import { IStore } from 'store/configureStore';

const selectEditClientLogoStateState = (state: IStore) => state.modules.settings.clientsSettings.clients.editClientLogo;
export const selectEditLogoClientId = (state: IStore) => selectEditClientLogoStateState(state).clientId;
export const selectIsClientLogoUpdating = (state: IStore) => selectEditClientLogoStateState(state).isUpdating;
